import { fontTokens } from './fontTokens'
import { colorTokens } from './colorTokens'
import { radiusTokens } from './radiusTokens'
import { spaceTokens } from './spaceTokens'
import { motionDurationTokens, motionDurationVarTokens } from './motionDurationTokens'
import { motionEasingTokens, motionEasingVarTokens } from './motionEasingTokens'
import {
  motionDelayVarTokens,
  motionStaggerVarTokens,
  motionNudgeVarTokens,
} from './motionDelayStaggerTokens'

export const tokens = {
  font: fontTokens,
  color: colorTokens,
  radius: radiusTokens,
  space: spaceTokens,
  motion: {
    duration: motionDurationTokens,
    durationVar: motionDurationVarTokens,
    easing: motionEasingTokens,
    easingVar: motionEasingVarTokens,
    delayVar: motionDelayVarTokens,
    staggerVar: motionStaggerVarTokens,
    nudgeVar: motionNudgeVarTokens,
  },
  z: {
    base: 0,
    overlay: 1100,
    modal: 1300,
    tooltip: 1500,
  },
}

export const focusRingSx = {
  '&:focus-visible': {
    outline: `2px solid ${colorTokens.focus}`,
    outlineOffset: 2,
  },
}
